import Tibbits from '@appblocks/codegeneration/Tibbits';
import {
    CodeBlock,
    BlockType,
    SettingType,
    TibboDataType,
} from '@appblocks/codegeneration/types';
import BaseTibbit from '@appblocks/codegeneration/Tibbits/_BaseTibbit';
import * as tios from './tios';
import * as simulator from './simulator';

export default class Tibbit_30 extends BaseTibbit {
    constructor() {
        super();
        this.id = 'tibbit_30';
        this.name = 'Tibbit 30';

        this.fileLinks = [
            // 'ssi\\ssi.tbs',
            // 'ssi\\ssi.tbh',
        ];

        const settings = [
            {
                id: 'TEMP_NAME',
                name: 'Temperature Name',
                settingType: SettingType.NAME,
                dataType: TibboDataType.FLOAT,
                default: '',
                required: true,
            },
            {
                id: 'HUM_NAME',
                name: 'Humidity Name',
                settingType: SettingType.NAME,
                dataType: TibboDataType.FLOAT,
                default: '',
                required: true,
            },
        ];

        this.settings = this.settings.concat(settings);

        this.files = [
            'libraries/super_i2c/super_i2c.tbh',
            'libraries/super_i2c/super_i2c.tbs',
            'libraries/tibbits/tbt30/tbt30.tbh',
            'libraries/tibbits/tbt30/tbt30.tbs',
            'libraries/ssi/ssi.tbh',
            'libraries/ssi/ssi.tbs',
        ];
    }

    getCodeBlocks(): Array<CodeBlock> {
        if (this.project.runtime === 'simulator') {
            return simulator.getCodeBlocks(this);
        }
        return tios.getCodeBlocks(this);
    }
}
